module.exports = __webpack_public_path__ + "img/ewm.05c4f791.jpg";